import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

const variants = {
  primary:
    "bg-primary-600 hover:bg-primary-500 text-white shadow-lg shadow-primary-500/20 border border-primary-500",
  secondary:
    "bg-surface hover:bg-surface-hover text-white border border-white/10 hover:border-white/20",
  ghost: "bg-transparent hover:bg-white/5 text-gray-400 hover:text-white",
  glass:
    "bg-glass backdrop-blur-md border border-glass-border text-white hover:bg-white/10",
  danger: "bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20",
};

const sizes = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-5 py-2.5 text-sm",
  lg: "px-7 py-3.5 text-base",
  icon: "p-2",
};

export default function Button({
  className = "",
  variant = "primary",
  size = "md",
  children,
  icon,
  loading = false,
  disabled = false,
  onClick,
  type = "button",
  ...props
}) {
  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      type={type}
      className={`
        relative inline-flex items-center justify-center gap-2 rounded-xl font-medium transition-all duration-300
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}
      {!loading && icon && <span className="flex items-center">{icon}</span>}
      {children}
      
      {/* Subtle shine effect for primary buttons */}
      {variant === 'primary' && (
        <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/20 pointer-events-none" />
      )}
    </motion.button>
  );
}
